// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1OWCW","label":"Radio_label__1k9fe","checkMark":"Radio_checkMark__uUWkN","disabled":"Radio_disabled__2PbTj"};